const podcasts_pt = require('./podcasts.json')
export default podcasts_pt